/**
 * 通过时区转换时间
 * @param date 时间
 * @param add 默认时间时区
 * @param fmt 格式化格式
 * @returns 
 */
export const FormatDateZone = (dateStr: any, add = 8, fmt = 'YYYY-mm-dd HH:MM:SS') => {
  let date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    return "--";
  }
  let zone = 0 - new Date().getTimezoneOffset() / 60;
  let t = date.getTime() + (zone - add) * 60 * 60 * 1000;
  date = new Date(t);

  const opt = {
    'Y+': date.getFullYear().toString(),
    'm+': (date.getMonth() + 1).toString().padStart(2, '0'),
    'd+': date.getDate().toString().padStart(2, '0'),
    'H+': date.getHours().toString().padStart(2, '0'),
    'M+': date.getMinutes().toString().padStart(2, '0'),
    'S+': date.getSeconds().toString().padStart(2, '0')
  };

  for (const k in opt) {
    const regExp = new RegExp(k);
    if (regExp.test(fmt)) {
      fmt = fmt.replace(regExp, opt[k]);
    }
  }
  return fmt;
}

export interface CurrencyList {
  amount: number
  currency: string
  display_precision: number
  payment_type_list: Array<string>
  rate: number
  web_icon: string
}

/** 数字货币对象 */
export interface CryptoInfoObject {
  amount: number
  cancel_url: string
  currency: string
  description: string
  expires_at: string
  expires_in: number
  name: string
  order_no: string
  order_status: string
  out_order_no: string
  out_user_id: string
  out_user_name: string
  payment_url: string
  redirect_url: string
  cash_currency_config_list: Array<CurrencyList>,
  crypto_currency_config_list: Array<CurrencyList>,
  extend: any
}

/** 法币对象 */
export interface FiatInfoObject {
  amount: number
  cancel_url: string
  currency: string
  description: string
  expires_at: string
  expires_in: number
  name: string
  order_no: string
  order_status: string
  out_order_no: string
  out_user_id: string
  out_user_name: string
  payment_url: string
  redirect_url: string
  crypto_currency_config_list: Array<CurrencyList>,
  cash_currency_config_list: Array<CurrencyList>,
  extend: any
}